import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-report-badge-public',
  templateUrl: './report-badge-public.component.html',
  styleUrls: ['./report-badge-public.component.scss']
})
export class ReportBadgePublicComponent {
  @Input() public link: string;
}
